import React, { useMemo, useState, useEffect, useRef } from "react";
import { sendFavoritesToEmail } from "../../api";

// eslint-disable-next-line
export const EMAIL_PATTERN = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;

function AtlasMenuFavorites(props) {
    const { favoriteIds, closeModal } = props;
    const inputRef = useRef();
    const [email, setEmail] = useState("");
    const isEmailValid = useMemo(() => EMAIL_PATTERN.test(email), [email]);
    const hasFavoritesSelected = favoriteIds.length > 0;
    const copy = hasFavoritesSelected
        ? `You’ve added ${favoriteIds.length} ${
              favoriteIds.length === 1 ? "stop" : "stops"
          } to your Favorites list. Enter your email address below and we’ll send them to you`
        : "It looks like you haven't added any stops to your Favorites list yet. Once you do, come back to here to send the list to yourself.";

    useEffect(() => {
        inputRef.current.focus();
    }, []);

    const onSubmit = async event => {
        event.preventDefault();
        const res = await sendFavoritesToEmail({
            email,
            stopIds: favoriteIds,
        });

        if (!res) {
            //TODO: show error?
        } else {
            //TODO: show success
        }

        closeModal();
    };

    return (
        <form className="trpr-atlas-menu-modal" onSubmit={onSubmit}>
            <p>{copy}</p>
            <div className="trpr-atlas-menu-favorites__content">
                <input
                    ref={inputRef}
                    className="trpr-atlas__input"
                    type="email"
                    placeholder="Your email address"
                    value={email}
                    onChange={event => setEmail(event.target.value)}
                    disabled={!hasFavoritesSelected}
                />
                <button
                    className="trpr-atlas__button"
                    type="submit"
                    disabled={!hasFavoritesSelected || !isEmailValid || email.length === 0}
                >
                    Send
                </button>
            </div>
        </form>
    );
}

export default AtlasMenuFavorites;
